module.exports = __webpack_public_path__ + "img/2.20f48f93.png";